var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 11.7835C15.7917 11.8797 15.7917 12.1203 15.625 12.2165L10.375 15.2476C10.2083 15.3438 10 15.2235 10 15.0311L10 8.96891C10 8.77646 10.2083 8.65618 10.375 8.7524L15.625 11.7835Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.25C0.585786 2.25 0.25 2.58579 0.25 3V9C0.25 9.41421 0.585786 9.75 1 9.75C1.41421 9.75 1.75 9.41421 1.75 9V3.75H20C20.4142 3.75 20.75 3.41421 20.75 3C20.75 2.58579 20.4142 2.25 20 2.25H1ZM23.75 20.75V12C23.75 11.5858 23.4142 11.25 23 11.25C22.5858 11.25 22.25 11.5858 22.25 12V20.25H1.75V19.2C1.75 18.7858 1.41421 18.45 1 18.45C0.585786 18.45 0.25 18.7858 0.25 19.2V20.75C0.25 21.3023 0.697714 21.75 1.25 21.75H22.75C23.3023 21.75 23.75 21.3023 23.75 20.75ZM1.53033 11.9697L3.53033 13.9697C3.82322 14.2626 3.82322 14.7374 3.53033 15.0303L1.53033 17.0303C1.23744 17.3232 0.762563 17.3232 0.46967 17.0303C0.176777 16.7374 0.176777 16.2626 0.46967 15.9697L1.93934 14.5L0.46967 13.0303C0.176777 12.7374 0.176777 12.2626 0.46967 11.9697C0.762563 11.6768 1.23744 11.6768 1.53033 11.9697ZM22.4697 9.03033C22.7626 9.32322 23.2374 9.32322 23.5303 9.03033C23.8232 8.73744 23.8232 8.26256 23.5303 7.96967L22.0607 6.5L23.5303 5.03033C23.8232 4.73744 23.8232 4.26256 23.5303 3.96967C23.2374 3.67678 22.7626 3.67678 22.4697 3.96967L20.4697 5.96967C20.1768 6.26256 20.1768 6.73744 20.4697 7.03033L22.4697 9.03033Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchActive);
export default __webpack_public_path__ + "static/media/watch-active.1d936cb3dc8b333b3edba652477e4c72.svg";
export { ForwardRef as ReactComponent };